<template>
    <div class="distribution-rule">
		<div class="module-item-style">
		    <div class="module-item-title">
		        <div class="isSwitch">
		            <span>客服分配设置</span>
		            <el-switch
		                    class="switch-btn"
		                    v-model="is_open_distribute_default_cs"
		                    @change="changeConfig('is_open_distribute_default_cs',is_open_distribute_default_cs)"
		                    active-color="#68B974">
		            </el-switch>
		        </div>
		
		    </div>
		    <div class="setting-distribution-tips">开启后，老访客咨询时优先由最后接待此访客的客服接待。默认开启</div>
		</div>
        <div class="module-item-style">
            <div>
                <p class="distribution-rule-title">选择分配规则</p>
                <el-radio-group v-model="distributionRule" class="distribution-rule-container"
                                @change="changeRule('cservice_allot_scheme')">
                    <el-radio class="distribution-rule-item" label="scheme_random">随机分配</el-radio>
                    <el-radio class="distribution-rule-item" label="scheme_precedence">按排序优先分配<span
                            class="rule-item-detail">(设定一个客服排序, 优先给排序靠前的客服分配到对话数量上限, 才会分配给排序下一位的客服)</span></el-radio>
                    <el-radio class="distribution-rule-item" label="scheme_take_turns">按排序轮流分配<span
                            class="rule-item-detail">(设定一个客服排序, 新的对话按此排序, 在可分配的客服间轮流分配)</span></el-radio>
                </el-radio-group>
            </div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title">
                <div class="isSwitch">
                    <span>超级管理员不参与自动分配</span>
                    <el-switch
                            class="switch-btn"
                            v-model="switchBtn"
                            @change="changeConfig('is_open_autodis_admin', switchBtn)"
                            active-color="#68B974">
                    </el-switch>
                </div>

            </div>
            <div class="setting-distribution-tips">开启后，超级管理员将不参加自动分配，默认关闭</div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title">
                <div class="isSwitch">
                    <span>普通客服修改服务上限权限</span>
                    <el-switch
                            class="switch-btn"
                            v-model="servicenumAuth"
                            @change="changeConfig('is_open_cs_servicenum_auth',servicenumAuth)"
                            active-color="#68B974">
                    </el-switch>
                </div>

            </div>
            <div class="setting-distribution-tips">开启后普通客服有修改自己服务上限权限，默认关闭</div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title">
                <div class="isSwitch">
                    <span>客服转接访客设置</span>
                    <el-switch
                            class="switch-btn"
                            v-model="is_open_switch_apply"
                            @change="changeConfig('is_open_switch_apply',is_open_switch_apply)"
                            active-color="#68B974">
                    </el-switch>
                </div>

            </div>
            <div class="setting-distribution-tips">是否开启转接申请设置，默认关闭</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'distribution-rules',
        data() {
            return {
                distributionRule: '',
                switchBtn: false,
                servicenumAuth: false,
                is_open_switch_apply: false,
				is_open_distribute_default_cs: true,
            }
        },
        created() {
            this.getRuleFn()
            this.getConfig()
        },
        mounted() {

        },
        methods: {
            getConfig() {
                this.$http.getConfigAPI().then(res => {
                    if (res.status == 1) {
                        if (res.data.is_open_autodis_admin == 0) {
                            this.switchBtn = false
                        } else if (res.data.is_open_autodis_admin == 1) {
                            this.switchBtn = true
                        }
                        if (res.data.is_open_cs_servicenum_auth == 0) {
                            this.servicenumAuth = false
                        } else if (res.data.is_open_cs_servicenum_auth == 1) {
                            this.servicenumAuth = true
                        }
						if (res.data.is_open_distribute_default_cs == 0) {
						    this.is_open_distribute_default_cs = false
						} else if (res.data.is_open_distribute_default_cs == 1) {
						    this.is_open_distribute_default_cs = true
						}
                        if (res.data.is_open_switch_apply == 0) {
                            this.is_open_switch_apply = false
                        } else if (res.data.is_open_switch_apply == 1) {
                            this.is_open_switch_apply = true
                        }
                    }
                })
            },
            /**
             * 获取设置的规则
             */
            getRuleFn() {
                this.$http.getRulesAPI().then(res => {
                    if (res.status == 1) {
                        this.distributionRule = res.data
                    }
                })
            },
            changeConfig(name, value) {
                if (value){
                     this.changeRule(name, '1')
                } else {
                    this.changeRule(name, '0')
                }
            },
            /**
             * 修改规则
             */
            changeRule(name, value) {
                this.$http.saveConfigAPI({
                    name: name,
                    value: value || this.distributionRule,
                }).then(res => {
                    if (res.status == 1) {
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss">
    .distribution-rule {
        .distribution-rule-title {
            line-height: 40px;
            color: #333;
            /*margin-top: 20px;*/
        }

        .distribution-rule-container {
            .distribution-rule-item {
                display: block;
                line-height: 30px;
                color: #333;
                white-space: inherit;

                .rule-item-detail {
                    color: #999;
                    line-height: 1;
                    display: block;
                    padding-left: 23px;
                }
            }
        }

        .isSwitch {
            display: flex;

            .switch-btn {
                margin-left: auto;
            }
        }

        .distribution-tab {
            li + li {
                margin-left: 20px;
            }

            li {
                float: left;
                cursor: pointer;
                padding-bottom: 7px;

                &.tabActived {
                    border-bottom: 5px solid #428EFE;
                }
            }
        }
    }
</style>
